import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { Layout } from '../components/layout';
import PricesBridged from '../components/Prices/prices';
import Seo from '../components/seo';

const PricesPage = ({ pageContext }) => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Seo title={t('trans.prices')} lang={pageContext.language} />
      <PricesBridged />
    </Layout>
  );
};
export default PricesPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
